<template>
  <div class="two">
    <oneCol
      style="flex:1;margin-right:20px"
      url="home/HomeGetSzNews"
      :param="{ top: 4, type:5 }"
      text="先锋模范"
      type="3"
      more-url="/main?type=1&selected=3"
    />

    <oneCol
      style="flex:1;margin-right:20px"
      url="home/HomeGetSzNews"
      :param="{ top: 4, type: 6 }"
      text="办事流程"
      type="3"
      more-url="/main?type=1&selected=5"
    />

    <oneCol
      style="flex:1;margin-right:20px"
      url="home/HomeGetSzNews"
      :param="{ top: 4, type: 10 }"
      text="三务公开"
      type="3"
      more-url="/main?type=4&selected=0"
    />

  </div>
</template>

<script>
import oneCol from '../oneCol.vue'
export default {
  components: {
    oneCol
  },
  data() {
    return {
    }
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.two {
  display: flex;
}
.rightContent {
  img {
    width: 100%;
    height: 200px;
  }

  .twoItem {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 199px;
      height: 132px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      padding: 31px 0 21px 0;
    }
    .item > div > img {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }
    .item > div > span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .item > span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
    }
  }
}
</style>
